import { Component, OnInit } from '@angular/core';
import { LoadingProvider } from '@app/components/_shared/loading-spinner/loading-spinner.component';
import { LocalisationService } from '@app/services/localisation.service';
import { UserService } from '@app/services/user.service';

@Component({
  selector: 'app-privacy-policy',
  templateUrl: './privacy-policy.component.html',
  styleUrls: ['./privacy-policy.component.scss']
})
export class PrivacyPolicyComponent implements OnInit {
  static route: string = 'privacy';

  locale: any = {};
  policyText: string;

  constructor(
    private localisation: LocalisationService,
    private userService: UserService,
    private spinner: LoadingProvider
  ) {}

  ngOnInit() {
    this.locale = this.localisation.getTranslationsForComponent('PrivacyPolicyComponent');
    this.spinner.show();
    this.userService.getLegal().subscribe(
      legalText => {
        this.policyText = legalText.policyText;
      },
      err => {},
      () => {
        this.spinner.hide();
      }
    );
  }

  goBack() {
    window.history.back();
  }
}



// WEBPACK FOOTER //
// ./src/app/components/legal/privacy-policy/privacy-policy.component.ts